

/**
 * VRC.ContainerService
 * Service with functions that finds and manipulates containers.
 */

var VRC = VRC || {};
VRC.ContainerService = (function () {
	var _matches = [];
	/**
	 * Loops through the containerlist and return those without weight.
	 * @returns Array array with containers without weight.
	 */
	var findContainersWithoutWeight = function () {
		var containersWithoutWeight = [];
		$.each(g_container_list, function (key, container) {

			if (!container.hasWeight()) {
				containersWithoutWeight.push(container);
			}
		});
		return containersWithoutWeight;
	};
	/**
	 * Hightligts containers without weight.
	 */
	var highligthContainersWithoutWeight = function (deckId) {
		HighlightContainers('clear');
		var containers = findContainersWithoutWeight();

		for (var ii = 0; ii < containers.length; ii++) {
			var container = containers[ii];
			if (container.deckID == deckId) {
				highLightContainer(container.id);
			}
		}
	};

	/**
	 * Hightligts a single container
	 * @param containerId
	 */
	var highLightContainer = function (containerId) {

		$('#' + containerId).addClass('highlighted');
	};

	var getContainerById = function (id) {
		return _.find(g_container_list, function (container) {
			return container.getId() === id;
		});
	};

	var getContainersWithRules = function (id) {
		return _.filter(g_container_list, function (container) {
			if (container.getId() === id) {
				return false;
			}
			if (!container.isOnDeck()) {
				return false;
			}
			return container.hasDgClass();
		});
	};

	var rules = {
		"1": 3,
		"2": 6,
		"3": 12,
		"4": 24
	};

	var isRelevantRule = function (rule) {
		return rule !== null && rule !== "*" && rule !== 'X';
	};

	function getConflictedContainers (id) {
		_matches = [];
		var baseContainer = getContainerById(id);

		if (baseContainer.hasDgClass()) {

			var containers = getContainersWithRules(baseContainer.getId());

			// check each container against dragged container and all rules
			_matches = _.map(containers, function (container) {

				var baseRules = baseContainer.getDgClass().split(',');
				var containerRules = container.getDgClass().split(',');

				// Go over rules from base containers vs each rule for second container. We want to keep the one with highest segregation (meters)
				var temp_match = _.map(baseRules, function(rule1) {

                    var _temp_match = _.map(containerRules, function (rule2) {

                        var rule = VRC.MasterDataService.getDgSegRule(rule1, rule2);

                        if (isRelevantRule(rule)) {
                            var meters = rules[rule];

                            var yM2 = VRC.Utils.Number.parseFloat(container.position.y) - (meters);
                            var widthM2 = VRC.Utils.Number.parseFloat(container.features.width) + (meters * 2);
                            var lengthM2 = VRC.Utils.Number.parseFloat(container.features.length) + (meters * 2);
                            if (container.features.rotation > 0) {
                                widthM2 = VRC.Utils.Number.parseFloat(container.features.length) + (meters * 2);
                                lengthM2 = VRC.Utils.Number.parseFloat(container.features.width) + (meters * 2);
                            }

                            var xM2 = VRC.Utils.Number.parseFloat(container.position.x) - (meters);

                            var deckWidthM2 = g_current_deck.width;
                            if ((widthM2 + yM2) > deckWidthM2) {
                                var overflow = (widthM2 + yM2) - deckWidthM2;
                                widthM2 = widthM2 - overflow;//Remove overflow in bottom of deck.
                            }

                            var width = CalculatePresentageOfDeckWidth(widthM2);
                            var y = CalculatePresentageOfDeckWidth(yM2);
                            var x = CalculatePresentageOfDeckLength(xM2);
                            var length = CalculatePresentageOfDeckLength(lengthM2);

                            return {
                                length: length,
                                width: width,
                                x: x,
                                y: y,
								meter: meters,
                                boundries: {
                                    top: yM2,
                                    left: xM2,
                                    right: xM2 + lengthM2,
                                    bottom: yM2 + widthM2
                                },

                                dgClass: rule2

                            };
                        }
                    });
                    return _temp_match;
                });
                temp_match = _.flatten(temp_match);
                temp_match = _.filter(temp_match, function(match) {return match !== undefined});
                if(temp_match.length > 0) {
                    temp_match = _.max(temp_match, function (o) {
                        return o.meter
                    });
                }
                else {
                	temp_match = undefined;
				}

				return temp_match;

			});
		}
		_matches = _.filter(_matches, function (match) {
			return match !== undefined;
		});
		return _matches;
	};

	var drawConflictedStatus = function (id) {

		var $deck = $("#deck");

		var overlays = getConflictedContainers(id);
		_.each(overlays, function (overlay) {
			$deck.append(WELL.Handlebars.VRC['dg_segregation_overlay'](overlay));
		});
	};

	var isInSideBoundries = function (dropped, boundry) {
		return !(dropped.left > boundry.right ||
		dropped.right < boundry.left ||
		dropped.top > boundry.bottom ||
		dropped.bottom < boundry.top);
	};

	var clearConflictedStatus = function (id) {
		var container = g_container_list[id];

		var boundries = {
			top: container.position.y,
			left: container.position.x,
			bottom: VRC.Utils.Number.parseFloat(container.features.width) + container.position.y,
			right: VRC.Utils.Number.parseFloat(container.features.length) + container.position.x
		};

		var isViolation = _.find(_matches, function (match) {
			return isInSideBoundries(boundries, match.boundries);

		});

		if (isViolation) {
			setTimeout(
				function () {
					var msg = 'Warning. This placement indicates a violation of the segregation rules.';
					alert(msg);
				}
				, 100);
		}

		_matches = [];
		$(".deck-state__dg-segregation-overlay").remove();

	};

	var findAdHocContainers = function () {
		return _.filter(g_container_list, function (container) {
			var searchString = "container_";
			var id = container.id;
			return id.length > 0 && id.substring(0, searchString.length) === searchString;
		})
	};

	var hasSameTag = function (container1, container2) {

		if (!container1 || !container2) {
			return false;
		}

		var tag1 = container1.tag;
		var tag2 = container2.tag;

		if (!tag1 || !tag2) {
			return false;
		}
		if (tag1.length === 0 || tag2.length === 0) {
			return false;
		}
		tag1 = sanitizeString(tag1);
		tag2 = sanitizeString(tag2);

		return tag1 === tag2;
	};

	var sanitizeString = function (inpup) {
		return inpup.replace(/[-_,.\s]/g, '').toLowerCase();
	};

	var findManifestedContainers = function (adHocContainers) {
		adHocContainers = adHocContainers || findAdHocContainers();
		return _.difference(g_container_list, adHocContainers);
	};

	var findManifestedTransitContainers = function (adHocContainers) {
		var manifestedContainers = findManifestedContainers(adHocContainers);
		return _.filter(manifestedContainers, function (container) {
			return container.deckID === "transit_area";
		});
	};

	var findMatchingContainers = function () {
		var adHocContainers = findAdHocContainers();
		var manifestedContainers = findManifestedTransitContainers(adHocContainers);

		var matches = [];
		_.each(manifestedContainers, function (container) {

			var matchingAdHocContainer = _.find(adHocContainers, function (adHocContainer) {

				return hasSameTag(container, adHocContainer);
			});

			if (matchingAdHocContainer) {
				matches.push({container: container, adHocContainer: matchingAdHocContainer})
			}

		});
		return matches;
	};

	var switchContainers = function (matches) {
		_.each(matches, function (match) {
			match.container.position = match.adHocContainer.position;
			match.container.features.rotation = match.adHocContainer.features.rotation;
			match.container.deckID = match.adHocContainer.deckID;
			match.container.InitialiseVisual("#deck");
			g_container_list[match.container.id] = match.container;
			delete g_container_list[match.adHocContainer.id];
			$("#" + match.adHocContainer.id).remove();
		});
	};

	return {
		getContainersWithRules: getContainersWithRules,
		getConflictedContainers: getConflictedContainers,
		drawConflictedStatus: drawConflictedStatus,
		clearConflictedStatus: clearConflictedStatus,
		getContainerById: getContainerById,
		findContainersWithoutWeight: findContainersWithoutWeight,
		highligthContainersWithoutWeight: highligthContainersWithoutWeight,
		findAdHocContainers: findAdHocContainers,
		findMatchingContainers: findMatchingContainers,
		switchContainers: switchContainers
	};
})();








